import { computed, observable } from "mobx"
import { toast } from "sonner"

import { formatErrorMessage } from "@/lib/displayUtils.ts"
import { submitGeneric } from "@/lib/formUtils.ts"
import { Model } from "@/lib/Model.ts"
import { ellipsize } from "@/styles/textStyles.ts"

import type { OrgContext } from "@/lib/context.ts"

export class ProjectNameFormModel extends Model {
  readonly creating = observable.box(false)

  constructor(readonly taskId: string, readonly suggestedName: string, readonly context: OrgContext) {
    super("ProjectNameFormModel")
  }

  readonly text = computed(() => {
    return this.creating.get() ? ellipsize("Setting project name") : `Let's name it "${this.suggestedName}"`
  })

  async submit() {
    await submitGeneric({
      isSubmitting: this.creating,
      context: this.context,
      submit: async () => {
        try {
          await this.context.queries.apiClient.setProjectName(this.taskId, this.suggestedName, true)
        } catch (e) {
          toast.error(formatErrorMessage(e, "Failed to set project name"))
        }
      }
    })
  }
}